'use strict'

{ escape }         = require '../../general/m_underscore_replacements'

{ fixLatOrLng } = require './m_location_helper' # for unknown reason this doesn't work / the function fails with unknown constructor error

{ setTranslations, getTranslations } = require './m_translations'

###*
# Generate basic bloodhound tag name
#
# @param   {String} [type]     - Name of the api / collection name
# @param   {String} attributes
# @returns {String} bhw        - Base bloodhound tag
###
createBloodhoundTag = (type = '') ->
  type.split('|').slice(-1).join('').toLowerCase()


###*
# Build L1 Category header partial
#
# @param   {String} type - category type
# @returns {String}      - HTML partial containing L0 category heading
###
getHeadingPartial = (type) ->
  translations = getTranslations()
  txt = translations?.categories[type]
  if txt
    "<div class='tw-heading tw-#{ type }'>#{ txt }</div>"
  else
    ''

templateAttributesForSubcategories = (args...) ->
  [id, sectionID, prefix] = args

  htmlOpenTag   = 'span class="icon-plus tw-caption"'
  htmlCloseTag  = 'span'
  # indicate that element controls a submenu with a certain id
  menuID = "#{prefix}tw-#{ id }-menu"
  ariaAttributes = " role='link' aria-controls='#{ menuID }' aria-owns='#{ menuID }' aria-haspopup='true' "
  # generate path, which can be used to get the correct subcategories when required
  catInfo = " cat='#{ id }' cat-path='#{ sectionID }|#{ id }'"
  ariaListAttributes = ' aria-live="polite"'

  [htmlOpenTag, htmlCloseTag, ariaAttributes, ariaListAttributes, catInfo]

###*
# Build Category partial
#
# @param   {Array}   collection - List of items
# @param   {String}  sectionID  - category section name
# @param   {Number}  [level]    - Optional parameter representing the taxonomy
# @param   {Number}  [prefix]   - Optional prefix for id generation
# @returns {String}             - HTML String
###
partialSearchCategoryList = (collection, sectionID, level = 1, prefix = '') ->
  return '' if not collection?.length
  allTranslations = getTranslations()

  list = []
  url = ''
  baseBHC = createBloodhoundTag(sectionID)

  baseObject = collection.shift()
  { baseUrl } = baseObject
  if not baseUrl
    baseUrl = false
    collection.unshift baseObject

  while item = collection.shift()
    ###
    # item can be either of type "Array" or "Object"
    # API facets are normally mapped as arrays
    # while config or constructed entries (all deals) ar
    # mapped as object.
    ###
    if Array.isArray(item)
      continue unless baseUrl
      [id, friendlyName, count, subcategories] = item
      url = baseUrl + id
    else
      { i: id, n: friendlyName, c: count, s: subcategories, u: url, newBadge } = item

    ariaAttributes = ariaListAttributes = catInfo = newBadgeTag = ''
    countString = if count then " <span class='tw-count'>(#{ count })</span>" else ''
    bhc = baseBHC + ':'
    if id then bhc += id.toLowerCase() else bhc += 'all-deal'

    if newBadge and (newBadgeTxt = allTranslations.general.newbadge)
      newBadgeTag = "<span class='new-badge'>#{ newBadgeTxt }</span>"

    if subcategories?.length
      attributes = templateAttributesForSubcategories(id, sectionID, prefix)
      [htmlOpenTag, htmlCloseTag, ariaAttributes, ariaListAttributes, catInfo] = attributes
    else
      # case getaways or when subcatories don't
      url = if url then "href='#{ url }' " else ''
      htmlOpenTag   = "a #{ url }class='tw-link'"
      htmlCloseTag  = 'a'

    template =
    """
<li class='tw-item tw-cat-item tw-cat-L#{ level }'#{ ariaListAttributes }>
<#{ htmlOpenTag } data-bhc='#{ bhc }' #{ catInfo } #{ ariaAttributes }>#{ newBadgeTag }#{ friendlyName }#{ countString }</#{ htmlCloseTag }>
</li>
"""
    list.push(template)

  if list.length
    menuID = sectionID.split('|').pop()
    list.unshift("<ul id='#{prefix}tw-#{ menuID }-menu' class='tw-cat-menu tw-cat-menu-L#{ level }' data-bhw='#{ menuID }'>")
    list.push("</ul>")

  list.join('')

###*
# Build Category lists and wrap them
#
# @param   {Array}   collections    - List of items
# @param   {Array}   [prefix]       - Prefix for id generation (Optional)
# @param   {Boolean} [m2016]        - Mobile2016 flag (Optional)
# @returns {Object}  {list[]}       - List of categories
###
partialSearchCategories = (collections, prefix = '', m2016 = true) ->
  item = collections[0]
  listItems = []
  for type, collection of item
    if collection?.length
      heading = getHeadingPartial(type)
      listItems.push("<li id='#{prefix}tw-#{ type }' class='tw-category'>#{ heading }")
      listItems.push partialSearchCategoryList(collection.slice(0), type, 1, prefix, m2016)
      listItems.push("</li>")

  {
    list: listItems
  }


###*
# Returns list of recent searches queries retrieved from localStorage
#
# param    {String} - Input type
# @returns {Array}  - list
###
getRecentSearches = (type = 'deal') ->
  list = []
  try
    switch type
      when 'deal'
        list = JSON.parse(window.localStorage?.getItem('LS_recentSearches') or '[]')

      when 'location'
        list = JSON.parse(window.localStorage?.getItem('LS_recentLocations') or '[]')

  list


###*
# Move typeahead container into its context.
# This is only needed for desktop
#
# @param {Object} $container - Selector for typeahead wrapper
# @param {String} ctx        - Typeahead context
# @param {String} env        - Environment
###
moveAutocomplete = ($container, ctx, env) ->
  if env is 'desktop'
    switch ctx
      when 'search'
        selector = '.deal-search'
      when 'location'
        selector = '.location-search'
    if selector and not $container.hasClass 'typeahead-modal'
      $(selector).append($container)

  return


###*
# Convert, prepend and save term to recent searches list
#
# @param {String} term   - Deal query entered by user
# @param {String} [type] - input type (Optional)
###
removeRecentSearch = (term, type = 'deal') ->
  type = 'deal' if type is 'search'

  keywords = getRecentSearches(type) or []
  term = escape(term).trim().toLowerCase()
  switch type
    when 'deal'
      index = keywords.findIndex (n) -> n.toLowerCase() is term
    when 'location'
      index = keywords.findIndex (n) ->
        if n.address
          return escape(n.address).trim().toLowerCase() is term
        false

  if index > -1
    keywords.splice(index, 1)

  setRecentSearches keywords, type
  return

###*
# Helper function to remove stored searches
#
# @param {String} type - Input type
###
removeRecentSearches = (type = 'deal') ->
  type = 'deal' if type is 'search'
  switch type
    when 'deal'
      window.localStorage.removeItem 'LS_recentSearches'
    when 'location'
      window.localStorage.removeItem 'LS_recentLocations'
  return

###*
# Saves recent searches array as string in localStorage
#
# @param {Array}  keywords - List of keywords searched by user
# @param {String} type     - input type
###
setRecentSearches = (keywords, type) ->

  switch type
    when 'deal'
      key = 'LS_recentSearches'
    when 'location'
      key = 'LS_recentLocations'

  try
    window.localStorage?.setItem(key, JSON.stringify(keywords))

###*
# Convert, prepend and save term to recent searches list
#
# @param {String} term - Deal query entered by user
# @param {String} type - input type (Optional)
# @param {String} env  - Environment. Controls amount of items (Optional)
###
saveRecentSearch = (term, type = 'deal', env = 'desktop') ->
  amount = if type is 'deal' and env is 'mobile' then 5 else 10

  keywords = getRecentSearches(type) or []
  switch typeof term
    when 'string'
      term = escape(term).trim().toLowerCase()
      return if term is ''
      index = keywords.findIndex (n) -> n is term
    when 'object'
      index = keywords.findIndex (n) -> n.address is term.address

  if index > -1
    keywords.splice(0, 0, keywords.splice(index, 1)[0]) # move term to the beginning
  else
    keywords.unshift(term)  # prepend term

  setRecentSearches keywords.slice(0, amount), type
  return

###*
# Get subcategory collection and its taxonomy level
#
# @param   {Array}                            collections
# @param   {Array}                            path
# @param   {Number}                           [level] - Taxonomy level
# @returns {{collection.Array, level.Number}}
###
getSubCategoryCollection = (collections, path, level = 1) ->
  collection = collections
  id = undefined

  ###*
  # Condition to find matching item with categories
  # Checks if ID (i) matches and if subcategories (s) exists
  #
  # @param   {Object} item  - Array item
  # @returns {Boolean}      - Condition being passed to Array.prototype.find() to return object
  ###
  findSubCategory = (item) ->
    # id AND subcategories
    # format convention for "item": [id, friendlyName, count, children]
    item[0] is id and item[3]?.length

  ###
  # NOTE: This might be more efficient with Array::reduce

    findSubCategory = (item) ->
      if item[0] is id and item[3]?.length
        return item[3]
    level++ if (collection = collection.reduce(findSubCategory))

  ###
  while id = path.shift()
    if temp = collection.find(findSubCategory)
      collection = temp[3].slice(0)
      level++

  {
    collection
    level
  }

fixStoredRecentLocation = ->
  requestIdleCallback ->
    type = 'location'
    locations = getRecentSearches(type)
    locations = locations.map (location) ->
      { lat, lng } = location
      Object.assign {}, location, {lat: fixLatOrLng(lat), lng: fixLatOrLng(lng)}

    setRecentSearches locations, type


module.exports = {
  createBloodhoundTag
  fixStoredRecentLocation
  getHeadingPartial
  getRecentSearches
  getSubCategoryCollection
  moveAutocomplete
  partialSearchCategories
  partialSearchCategoryList
  removeRecentSearch
  removeRecentSearches
  saveRecentSearch
  setRecentSearches
  templateAttributesForSubcategories
}
